import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import ChevronSmallDown from '@elliemae/ds-icons/ChevronSmallDown';
import DSButton from '@elliemae/ds-button';

var DropdownIndicator = function DropdownIndicator(_ref) {
  var innerRef = _ref.innerRef,
      onKeyDown = _ref.onKeyDown;
      _ref.clearValue;
      _ref.getStyles;
      _ref.getValue;
      _ref.setValue;
      _ref.hasStyle;
      _ref.hasValue;
      _ref.isMulti;
      _ref.isRtl;
      _ref.isDisabled;
      _ref.isFocused;
      _ref.selectOption;
      _ref.selectProps;
      _ref.innerProps;
      var rest = _objectWithoutProperties(_ref, ["innerRef", "onKeyDown", "clearValue", "getStyles", "getValue", "setValue", "hasStyle", "hasValue", "isMulti", "isRtl", "isDisabled", "isFocused", "selectOption", "selectProps", "innerProps"]);

  return /*#__PURE__*/React.createElement(DSButton, _extends({
    "aria-label": "dropdown-indicator",
    buttonType: "text",
    className: "dropdown-indicator",
    icon: /*#__PURE__*/React.createElement(ChevronSmallDown, null),
    innerRef: innerRef,
    onKeyDown: onKeyDown
  }, rest));
};

export default DropdownIndicator;
//# sourceMappingURL=DropdownIndicator.js.map
